export const CHIP_DATA_IDS = {
  base: 'chip',
  container: '',
  deleteBtn: 'delete'
};
